'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
                                                                                                                                                                                                                              * 輸入無效資料時，不會 call onChange
                                                                                                                                                                                                                              */


// ISSUE 用 customInput 來處理 style?
function DatePicker(props) {
  var isInvalid = props.isInvalid,
      inputRef = props.inputRef,
      passing = _objectWithoutProperties(props, ['isInvalid', 'inputRef']);

  return _react2.default.createElement(_reactDatepicker2.default, _extends({
    ref: inputRef,
    popoverAttachment: 'top left',
    popoverTargetAttachment: 'bottom left',
    className: isInvalid ? 'invalid-input is-invalid' : ''
  }, passing));
}

var bool = _propTypes2.default.bool,
    func = _propTypes2.default.func;

DatePicker.propTypes = {
  isInvalid: bool,
  onChange: func.isRequired,
  onChangeRaw: func,
  inputRef: func
};

exports.default = DatePicker;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/DatePicker/DatePicker.js
// module id = 1748
// module chunks = 0